// Using Vue for the product quantities
// Get the divisible property, from the Tag
let perBox = document.getElementById('perBox').value;
let price = document.getElementById('currentPrice').innerHTML;

var elements = document.querySelectorAll('.items-per-hundred-sqft');
var elements2 = document.querySelectorAll('.starter-strips-product');

var hardwareProducts = [];
elements.forEach(function(item) {
  hardwareProducts.push({
    id: item.dataset['id'],
    sqftPerOne: item.dataset['value'],
    price: item.dataset['price']
  })
})

var starterStripsProducts = [];
elements2.forEach(function(item) {
  starterStripsProducts.push({
    id: item.dataset['id'],
    price: item.dataset['price']
  })
})

new Vue({ 
  el: '#SQFTquantities',
  data: function () {
    return {
      sqftTotals: 0,
      boxQty: 0,
      sqftQty: 0,
      addOnsQty: {},
      hasWastage: false,
      wastagePercent: 0,
      originalSqft: null,
      originalBox: null
    }
  },
  computed: 
  {
    totalPrice() {
      var addOnPrices = 0;
      var self = this;
      var boxPrice = this.boxQty * price;
      hardwareProducts.forEach(function(product) {
        var qty = self.addOnsQty[product.id] ? self.addOnsQty[product.id] : 0;
        var addOnPrice = product.price * qty;
        addOnPrices += addOnPrice;
      })
      starterStripsProducts.forEach(function(product) {
        var qty = self.addOnsQty[product.id] ? self.addOnsQty[product.id] : 0;
        var addOnPrice = product.price * qty;
        addOnPrices += addOnPrice;
      })
      var sum = boxPrice + addOnPrices;
      return sum.toFixed(2);
    },
    totalSQFT() {
      return total.totalTotal;
    },
    totalWidth() {
      return total.totalWidth; 
    }
  },
  watch: {
    totalSQFT(newV) {
      this.sqftQty = newV;
      this.boxQty = Math.ceil(this.sqftQty / perBox);
      
      this.saveOriginalValues();
      this.hasWastage = false;
      this.updateAddOnsQty();
    },
    hasWastage(newV) {
      if (newV) {
        if (this.wastagePercent === 0) this.wastagePercent = 10
		this.calculateWastageAmounts()
      } else {
        this.sqftQty = this.originalSqft
        this.boxQty = this.originalBox
      }
      this.updateAddOnsQty();
    },
  },
  methods:
  {
    updateBoxQty(event) {
      this.boxQty = event.target.value;
      this.sqftQty = this.boxQty * perBox;
      
      
      this.saveOriginalValues();
      this.hasWastage = false;
      this.updateAddOnsQty();
    },
    updateAddOnsQty() {
      var self = this;
      hardwareProducts.forEach(function (product) {
        self.addOnsQty[product.id] = Math.ceil(self.sqftQty / product.sqftPerOne);
      });
      starterStripsProducts.forEach(function (product) {
        self.addOnsQty[product.id] = Math.ceil(total.totalWidth / 4);
      });
    },
    // SQFT QTY change
    onSQFTChange(event) {
      this.sqftQty = event.target.value;
      this.boxQty = Math.ceil(this.sqftQty / perBox);
      
      this.saveOriginalValues();
      this.hasWastage = false;
      this.updateAddOnsQty();
      
    },
    // Hardwares QTY change
    plusQty(variant_id) {
      if (this.addOnsQty[variant_id]) {
        this.addOnsQty[variant_id]++;
      } else {
        this.addOnsQty[variant_id] = 1;
      }
      this.addOnsQty = { ...this.addOnsQty }
    },
    // Hardwares QTY change
    minusQty(variant_id) {
      if (this.addOnsQty[variant_id] || this.addOnsQty[variant_id] > 1) {
        this.addOnsQty[variant_id]--;
      } else {
        this.addOnsQty[variant_id] = 0;
      }
      this.addOnsQty = { ...this.addOnsQty }
    },
    // Wastage value change
    onWastageChange(event) {
      this.wastagePercent = event.target.value ? parseInt(event.target.value) : 0;
      this.calculateWastageAmounts();
      this.updateAddOnsQty();
    },
    calculateWastageAmounts() {
      let percent = this.wastagePercent/100;
      this.sqftQty = parseInt(this.originalSqft) + (this.originalSqft * percent)
      this.boxQty = Math.ceil(this.sqftQty / perBox);
    },
    saveOriginalValues() {
      this.originalSqft = this.sqftQty
      this.originalBox = this.boxQty
    }
  }
})


